import HTTPService from '@/services/Http';
// import logrocket from '@/services/logrocket';

import router from '@/router';

async function fetchSubscription({ commit }, payload) {
  const { paymentId, accessToken } = payload;

  try {
    const { data } = await HTTPService.fetchSubscription(paymentId, accessToken);
    return data;
  } catch (error) {
    // logrocket.logger(error);
  }
}

async function subscriptionAccess({ commit }, payload) {
  try {
    const { data } = await HTTPService.subscriptionAccess(payload);
    commit('SUBSCRIPTION', data);
  } catch (error) {
    // logrocket.logger(error);

    commit('SUBSCRIPTION', null);
    router.push({ name: 'SubscriptionSecure' });
  }
}

async function subscriptionCancel({ commit }, paymentId) {
  try {
    await HTTPService.subscriptionCancel(paymentId);
    commit('SUBSCRIPTION_STOPPED');
  } catch (error) {
    // logrocket.logger(error);
  }
}

export default {
  fetchSubscription,
  subscriptionAccess,
  subscriptionCancel,
};
